import { analyticsApiClient } from '@ikea-customer-self-serve/analytics-api-client';

const analytics = analyticsApiClient('spare-parts');

export default analytics;
